export default __webpack_public_path__ + "static/media/frg--walking-trails.c9fa70a5.png";